export default __webpack_public_path__ + "static/media/logoheader.bb53bedb.png";